export { StyledIcon } from './Icon.Styled'
